import React from 'react'
import { withFormik } from 'formik'
import { merge } from 'lodash'
import { compose } from 'redux'

import withPortalAutoRemoteSync from '../../../modules/common/withPortalAutoRemoteSync'
import InputText from '../../views/widgets/InputText'
import Field from '../../views/widgets/Field'
import { initialValueForMultiLangSupport } from '../../../modules/form/index'
import config from '../../../config'

const ImageListItemForm = ({
  values,
  handleChange,
  handleBlur,
  handleAutoSyncOnBlur,
}) => (
  <div>
    <Field label="ชื่อ">
      <InputText
        name="title.th"
        placeholder="Title"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.title.th}
      />
    </Field>
  </div>
)

const initialValues = () => ({
  title: initialValueForMultiLangSupport(config.supportedLanguages),
})

export default compose(
  withFormik({
    mapPropsToValues: ({ galleryImage }) => {
      return merge(initialValues(), galleryImage)
    },
    enableReinitialize: true,
  }),
  withPortalAutoRemoteSync(props => ({ path: `galleryImages.${props.index}` })),
)(ImageListItemForm)



// WEBPACK FOOTER //
// ./src/components/templates/image-list/ImageListItemForm.js